export const reflectionsNFTs = [

  {
    id: '2049-reflections-2044',
    name: '2049 // Reflections #2044',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_14_4_3.png',
    price: '0.45 ETH'
  },
  {
    id: '2049-reflections-2037',
    name: '2049 // Reflections #2037',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_1_8_0.png',
    price: '0.88 ETH'
  },
  {
    id: '2049-reflections-2047',
    name: '2049 // Reflections #2047',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_0_5_2.png',
    price: '0.32 ETH'
  },
  {
    id: '2049-reflections-2045',
    name: '2049 // Reflections #2045',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_26_4_2.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-2039',
    name: '2049 // Reflections #2039',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_43_2_3.png',
    price: '0.67 ETH'
  },
  {
    id: '2049-reflections-2043',
    name: '2049 // Reflections #2043',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_44_2_3.png',
    price: '0.95 ETH'
  },
  {
    id: '2049-reflections-2048',
    name: '2049 // Reflections #2048',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_19_6_3.png',
    price: '0.25 ETH'
  },
  {
    id: '2049-reflections-2046',
    name: '2049 // Reflections #2046',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_4_2_2.png',
    price: '1.08 ETH'
  },
  {
    id: '2049-reflections-2042',
    name: '2049 // Reflections #2042',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_12_8_3.png',
    price: '0.52 ETH'
  },
  {
    id: '2049-reflections-2038',
    name: '2049 // Reflections #2038',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_34_0_3.png',
    price: '0.78 ETH'
  },
  {
    id: '2049-reflections-2040',
    name: '2049 // Reflections #2040',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_45_5_3.png',
    price: '1.12 ETH'
  },
  {
    id: '2049-reflections-2041',
    name: '2049 // Reflections #2041',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_32_6_3.png',
    price: '0.35 ETH'
  },
  {
    id: '2049-reflections-2036',
    name: '2049 // Reflections #2036',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_33_4_1.png',
    price: '0.92 ETH'
  },
  {
    id: '2049-reflections-2035',
    name: '2049 // Reflections #2035',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_10_1_0.png',
    price: '0.48 ETH'
  },
  {
    id: '2049-reflections-2025',
    name: '2049 // Reflections #2025',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_3_7_0.png',
    price: '0.85 ETH'
  },
  {
    id: '2049-reflections-2034',
    name: '2049 // Reflections #2034',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_26_0_2.png',
    price: '1.18 ETH'
  },
  {
    id: '2049-reflections-2029',
    name: '2049 // Reflections #2029',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_7_1_3.png',
    price: '0.28 ETH'
  },
  {
    id: '2049-reflections-2033',
    name: '2049 // Reflections #2033',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_28_6_0.png',
    price: '0.75 ETH'
  },
  {
    id: '2049-reflections-2026',
    name: '2049 // Reflections #2026',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_17_4_0.png',
    price: '1.05 ETH'
  },
  {
    id: '2049-reflections-2032',
    name: '2049 // Reflections #2032',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_33_4_3.png',
    price: '0.42 ETH'
  },
  {
    id: '2049-reflections-2030',
    name: '2049 // Reflections #2030',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_33_7_2.png',
    price: '0.98 ETH'
  },
  {
    id: '2049-reflections-2031',
    name: '2049 // Reflections #2031',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ch_0_1_2.png',
    price: '0.55 ETH'
  },
  {
    id: '2049-reflections-2024',
    name: '2049 // Reflections #2024',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_8_3_0.png',
    price: '0.82 ETH'
  },
  {
    id: '2049-reflections-2028',
    name: '2049 // Reflections #2028',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_32_2_0.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-2023',
    name: '2049 // Reflections #2023',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_9_4_2.png',
    price: '0.38 ETH'
  },
  {
    id: '2049-reflections-2022',
    name: '2049 // Reflections #2022',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_45_3_2.png',
    price: '0.72 ETH'
  },
  {
    id: '2049-reflections-2027',
    name: '2049 // Reflections #2027',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_36_3_2.png',
    price: '1.02 ETH'
  },
  {
    id: '2049-reflections-2020',
    name: '2049 // Reflections #2020',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ch_0_2_0.png',
    price: '0.22 ETH'
  },
  {
    id: '2049-reflections-2021',
    name: '2049 // Reflections #2021',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_17_7_1.png',
    price: '0.95 ETH'
  },
  {
    id: '2049-reflections-2019',
    name: '2049 // Reflections #2019',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_2_1_1.png',
    price: '0.58 ETH'
  },
  {
    id: '2049-reflections-2016',
    name: '2049 // Reflections #2016',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_14_1_2.png',
    price: '0.88 ETH'
  },
  {
    id: '2049-reflections-2017',
    name: '2049 // Reflections #2017',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_21_8_2.png',
    price: '1.20 ETH'
  },
  {
    id: '2049-reflections-2018',
    name: '2049 // Reflections #2018',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_3_4_3.png',
    price: '0.35 ETH'
  },
  {
    id: '2049-reflections-2015',
    name: '2049 // Reflections #2015',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_34_9_0.png',
    price: '0.68 ETH'
  },
  {
    id: '2049-reflections-2014',
    name: '2049 // Reflections #2014',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_19_9_2.png',
    price: '1.08 ETH'
  },
  {
    id: '2049-reflections-2013',
    name: '2049 // Reflections #2013',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_32_4_1.png',
    price: '0.42 ETH'
  },
  {
    id: '2049-reflections-2012',
    name: '2049 // Reflections #2012',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_2_0_1.png',
    price: '0.92 ETH'
  },
  {
    id: '2049-reflections-2009',
    name: '2049 // Reflections #2009',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_3_3_3.png',
    price: '0.62 ETH'
  },
  {
    id: '2049-reflections-2010',
    name: '2049 // Reflections #2010',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_47_2_1.png',
    price: '0.85 ETH'
  },
  {
    id: '2049-reflections-2008',
    name: '2049 // Reflections #2008',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_37_5_1.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-2011',
    name: '2049 // Reflections #2011',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_24_0_0.png',
    price: '0.32 ETH'
  },
  {
    id: '2049-reflections-2006',
    name: '2049 // Reflections #2006',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_40_7_2.png',
    price: '0.75 ETH'
  },
  {
    id: '2049-reflections-2003',
    name: '2049 // Reflections #2003',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_28_3_1.png',
    price: '1.05 ETH'
  },
  {
    id: '2049-reflections-1997',
    name: '2049 // Reflections #1997',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_27_8_2.png',
    price: '0.45 ETH'
  },
  {
    id: '2049-reflections-2007',
    name: '2049 // Reflections #2007',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_4_3_0.png',
    price: '0.82 ETH'
  },
  {
    id: '2049-reflections-1998',
    name: '2049 // Reflections #1998',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_30_8_3.png',
    price: '1.12 ETH'
  },
  {
    id: '2049-reflections-2004',
    name: '2049 // Reflections #2004',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_44_6_1.png',
    price: '0.28 ETH'
  },
  {
    id: '2049-reflections-2000',
    name: '2049 // Reflections #2000',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_44_4_1.png',
    price: '0.78 ETH'
  },
  {
    id: '2049-reflections-2005',
    name: '2049 // Reflections #2005',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_44_0_0.png',
    price: '0.98 ETH'
  },
  {
    id: '2049-reflections-2002',
    name: '2049 // Reflections #2002',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_6_5_2.png',
    price: '0.52 ETH'
  },
  {
    id: '2049-reflections-1995',
    name: '2049 // Reflections #1995',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_12_6_1.png',
    price: '0.95 ETH'
  },
  {
    id: '2049-reflections-1996',
    name: '2049 // Reflections #1996',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_36_8_0.png',
    price: '0.65 ETH'
  },
  {
    id: '2049-reflections-1999',
    name: '2049 // Reflections #1999',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_13_5_3.png',
    price: '0.95 ETH'
  },
  {
    id: '2049-reflections-1994',
    name: '2049 // Reflections #1994',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_21_7_0.png',
    price: '0.35 ETH'
  },
  {
    id: '2049-reflections-2001',
    name: '2049 // Reflections #2001',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_25_7_1.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-1990',
    name: '2049 // Reflections #1990',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_31_7_3.png',
    price: '0.48 ETH'
  },
  {
    id: '2049-reflections-1992',
    name: '2049 // Reflections #1992',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_6_6_2.png',
    price: '0.82 ETH'
  },
  {
    id: '2049-reflections-1993',
    name: '2049 // Reflections #1993',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_2_6_0.png',
    price: '1.08 ETH'
  },
  {
    id: '2049-reflections-1989',
    name: '2049 // Reflections #1989',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_6_9_0.png',
    price: '0.25 ETH'
  },
  {
    id: '2049-reflections-1987',
    name: '2049 // Reflections #1987',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_37_1_0.png',
    price: '0.75 ETH'
  },
  {
    id: '2049-reflections-1991',
    name: '2049 // Reflections #1991',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_20_7_1.png',
    price: '1.12 ETH'
  },
  {
    id: '2049-reflections-1986',
    name: '2049 // Reflections #1986',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_13_4_0.png',
    price: '0.42 ETH'
  },
  {
    id: '2049-reflections-1980',
    name: '2049 // Reflections #1980',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_14_9_2.png',
    price: '0.92 ETH'
  },
  {
    id: '2049-reflections-1985',
    name: '2049 // Reflections #1985',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_27_4_3.png',
    price: '1.18 ETH'
  },
  {
    id: '2049-reflections-1971',
    name: '2049 // Reflections #1971',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_46_9_3.png',
    price: '0.38 ETH'
  },
  {
    id: '2049-reflections-1976',
    name: '2049 // Reflections #1976',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_0_5_2.png',
    price: '0.85 ETH'
  },
  {
    id: '2049-reflections-1988',
    name: '2049 // Reflections #1988',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_33_1_1.png',
    price: '1.05 ETH'
  },
  {
    id: '2049-reflections-1979',
    name: '2049 // Reflections #1979',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_23_5_2.png',
    price: '0.28 ETH'
  },
  {
    id: '2049-reflections-1973',
    name: '2049 // Reflections #1973',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_4_6_0.png',
    price: '0.72 ETH'
  },
  {
    id: '2049-reflections-1984',
    name: '2049 // Reflections #1984',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_29_0_3.png',
    price: '0.98 ETH'
  },
  {
    id: '2049-reflections-1970',
    name: '2049 // Reflections #1970',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_46_6_0.png',
    price: '0.45 ETH'
  },
  {
    id: '2049-reflections-1983',
    name: '2049 // Reflections #1983',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_31_9_0.png',
    price: '0.88 ETH'
  },
  {
    id: '2049-reflections-1982',
    name: '2049 // Reflections #1982',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_46_4_0.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-1975',
    name: '2049 // Reflections #1975',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_4_7_2.png',
    price: '0.32 ETH'
  },
  {
    id: '2049-reflections-1978',
    name: '2049 // Reflections #1978',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_26_1_0.png',
    price: '0.78 ETH'
  },
  {
    id: '2049-reflections-1981',
    name: '2049 // Reflections #1981',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_37_6_2.png',
    price: '1.02 ETH'
  },
  {
    id: '2049-reflections-1974',
    name: '2049 // Reflections #1974',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_39_6_3.png',
    price: '0.55 ETH'
  },
  {
    id: '2049-reflections-1972',
    name: '2049 // Reflections #1972',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_34_5_0.png',
    price: '0.95 ETH'
  },
  {
    id: '2049-reflections-1977',
    name: '2049 // Reflections #1977',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_22_3_1.png',
    price: '1.20 ETH'
  },
  {
    id: '2049-reflections-1969',
    name: '2049 // Reflections #1969',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_2_6_2.png',
    price: '0.22 ETH'
  },
  {
    id: '2049-reflections-1968',
    name: '2049 // Reflections #1968',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_5_5_1.png',
    price: '0.68 ETH'
  },
  {
    id: '2049-reflections-1963',
    name: '2049 // Reflections #1963',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_49_5_2.png',
    price: '1.08 ETH'
  },
  {
    id: '2049-reflections-1966',
    name: '2049 // Reflections #1966',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_5_7_3.png',
    price: '0.42 ETH'
  },
  {
    id: '2049-reflections-1965',
    name: '2049 // Reflections #1965',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_33_1_3.png',
    price: '0.82 ETH'
  },
  {
    id: '2049-reflections-1964',
    name: '2049 // Reflections #1964',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_5_5_2.png',
    price: '1.15 ETH'
  },
  {
    id: '2049-reflections-1967',
    name: '2049 // Reflections #1967',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_25_4_2.png',
    price: '0.35 ETH'
  },
  {
    id: '2049-reflections-1962',
    name: '2049 // Reflections #1962',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_19_7_0.png',
    price: '0.75 ETH'
  },
  {
    id: '2049-reflections-1961',
    name: '2049 // Reflections #1961',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_17_2_1.png',
    price: '1.05 ETH'
  },
  {
    id: '2049-reflections-1957',
    name: '2049 // Reflections #1957',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_30_5_2.png',
    price: '0.48 ETH'
  },
  {
    id: '2049-reflections-1960',
    name: '2049 // Reflections #1960',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_7_2_1.png',
    price: '0.92 ETH'
  },
  {
    id: '2049-reflections-1959',
    name: '2049 // Reflections #1959',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_18_1_2.png',
    price: '1.18 ETH'
  },
  {
    id: '2049-reflections-1958',
    name: '2049 // Reflections #1958',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_32_7_0.png',
    price: '0.28 ETH'
  },
  {
    id: '2049-reflections-1956',
    name: '2049 // Reflections #1956',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_2_7_3.png',
    price: '0.65 ETH'
  },
  {
    id: '2049-reflections-1953',
    name: '2049 // Reflections #1953',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_9_3_1.png',
    price: '0.98 ETH'
  },
  {
    id: '2049-reflections-1951',
    name: '2049 // Reflections #1951',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_26_3_1.png',
    price: '0.52 ETH'
  },
  {
    id: '2049-reflections-1955',
    name: '2049 // Reflections #1955',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_26_5_2.png',
    price: '0.88 ETH'
  },
  {
    id: '2049-reflections-1952',
    name: '2049 // Reflections #1952',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_35_4_1.png',
    price: '1.12 ETH'
  },
  {
    id: '2049-reflections-1947',
    name: '2049 // Reflections #1947',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_16_4_2.png',
    price: '0.32 ETH'
  },
  {
    id: '2049-reflections-1954',
    name: '2049 // Reflections #1954',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/ke_25_1_3.png',
    price: '0.78 ETH'
  },
  {
    id: '2049-reflections-1949',
    name: '2049 // Reflections #1949',
    image: 'https://ipfs.io/ipfs/bafybeih4tdh4mio7oz5au4pklomtowmsj24nw6gnt7xozx62hexxn37eie/sr_29_1_3.png',
    price: '1.05 ETH'
  }

    

];